import React from 'react';

import Logo from '../components/Logo';
import RoomCard from '../components/RoomCard';
import CreateRoomDialog from '../components/CreateRoomDialog';
import Video from '../components/Video';
import Capsule from '../components/Capsule';

import { Player, Controls } from '@lottiefiles/react-lottie-player';
import scanGif from '../json/portalGif.json';
import audioGif from '../json/listening.json';

import { CreateRoomBtn, JoinRoomBtn, CreateRoomMobBtn, JoinRoomMobBtn, MicButton, RoomStatusIconButton, HistortyBtn } from '../components/Button';
import { JoinRoomName, JoinRoomMobName } from '../components/TextField';
import { InputViolationToast } from '../components/Toast';

import Carousel from 'react-elastic-carousel';
import Analyzer from '../sonic/executor';

import Nav from '../components/Nav';
import { Divider, IconButton, Tooltip } from '@material-ui/core';
// import { MicOutlined } from '@material  -ui/icons';
import { ToastContainer, toast, Slide } from 'react-toastify';
import UserContext from '../context/userContext'
import '../css/Home.css';
import '../css/style.css';
import NavMenu from '../components/NavMenu';
import InfoPrompt from '../components/InfoPrompt';
import { GoogleLogin, GoogleLogout } from 'react-google-login';

const dragDrop = require('drag-drop');


class Home extends React.Component {

    constructor(props){
        super(props);
        
        this.state = { 
            userName : localStorage.getItem('UserName') || '',
            createRoomDialogFlag : false ,
            roomName : '',
            route : false,
            alert : false,
            sender : null,
            socketId : null,
            localRooms : [],
            errCode : "",
            analyzer : null,
            deferredPrompt: null,
            showInstall: false,
            micDisplay: true,
            roomIsPublic : true,
            openRoomInfo : false,
            displaySuggestions : false,
            view: this.props.view,
            slideout: null
        }
        this.remove = {
            display:'none'
        }

    }

    static contextType = UserContext;

    sonic = ()=> {        
            let bootstrap = (p)=> {
                let config = {
                    alphabet: '^ABCDEFGHIJKLMNOPQRSTUVWXYZ_$',
                    data: 'A',
                    charDuration: 0.3,
                    rampDuration: 0.14,
                    freqMin: 10500,
                    freqMax: 12500,
                    freqError: 50,
                    threshold: 0,
                    energyFilter: 115,
                    wait:10000
                } 
                let analyzer = new Analyzer(p, config);
                let cb = (params, energy, success, activate) => {
                    if (params[0] === "^" && params[params.length-1] === "$"){
                        params = params.slice(1,params.length-1)
                        params = params.split("").filter((e) => e != "_")
                        // document.querySelector("h2").innerHTML ="Result: "+params.join("")
                        let roomCode = params.join("");
                        if(roomCode.length === 9 || roomCode.length === 12){
                            roomCode = roomCode.slice(0,3)+'-'+roomCode.slice(3,6)+'-'+roomCode.slice(6,9);
                            roomCode = roomCode.toLowerCase();
                            this.setState({
                                roomName: roomCode,
                                route : true,
                                sender : { name : 'slave', socketId : null },
                            })
                        } else {
                            toast.error("Room name does not exist!")
                        }
                        console.log("[INFO] RECORDED", params.join(""), energy, success);
                    }
                }
                p.setup = () => {
                    analyzer.setup();
                }

                p.touchStarted = () => {
                    p.getAudioContext().resume();
                }

                p.draw = () => {
                    analyzer.draw();
                }

                analyzer.init(cb);

                this.setState({ analyzer });
            }
            new this.context.p5(bootstrap);
            
    }
    
    componentDidMount() {
        
        this.context.teleport.leaveRoom();
        if(this.props.location.state){
            let {error} = this.props.location.state;
            if(error){
                // this.setState({errCode : error, alert : true});
                toast.error(error)
                window.history.replaceState(null,"");
            }
        }

        window.onresize = (e)=>{
            let view = e.srcElement.innerWidth < 900 ? "mobile" : "desktop";
            if(view === 'mobile'){
                if(!this.state.slideout){
                    let slideout = new window.Slideout({
                        'panel': document.getElementById('homePage'),
                        'menu': document.getElementById('nav'),
                        'padding': 256,
                        'tolerance': 70,
                        'side':'right'
                    });
                    slideout.disableTouch()
                    this.setState({slideout})
                }
                this.setState({view})
            } else {
                this.setState({ view,slideout:null })
            }
        }

        if(this.state.userName === "") {
            this.setState({
                createRoomDialogFlag : true
            })
        }
        this.context.teleport.search((arr) => {
            if(this.state.localRooms.length < arr.length) {
                let nick = arr[arr.length-1].nickname;
                let sock = arr[arr.length-1].sourceSocket;
                this.createNotification(nick+" has created a portal in local network. Click to join!",sock)
            }
            this.setState({localRooms:arr})
          });

        this.sonic();

        window.addEventListener('appinstalled', (evt) => {
        // Log install to analytics
        this.context.setDf(null);
        });  

        
        if(this.state.view === 'mobile') {
            let slideout = new window.Slideout({
                'panel': document.getElementById('homePage'),
                'menu': document.getElementById('nav'),
                'padding': 256,
                'tolerance': 70,
                'side':'right'
              });
            slideout.disableTouch()
            this.setState({slideout})
        }
        
        

        // pwa share targer
        navigator.serviceWorker.addEventListener('message',(event) => {
            if(event.data.action === 'room') {
                this.setState({
                    roomName:"s-o-c",
                    route : true,
                    sender : {name : 'slave', socketId : event.data.name},
                })
            } 
        })  
        
        if(this.context.webShare){
            this.handleCreateRoom();
        }  

        // drag nd drop on home screen
        dragDrop('#home',{
            onDrop: (files, pos, fileList, directories) => {
                this.context.setWs(fileList);
                this.handleCreateRoom();
            }
        })

        if(this.state.view === 'desktop'){
            document.querySelector("#telIcon").addEventListener("contextmenu",(e)=>{
                e.preventDefault();
                this.context.setWs("Clipboard");
                this.handleCreateRoom();
                return false;
            }, false)
        } else {
            document.querySelector("#homePage").oncontextmenu = function() { return false; }
        }

        document.querySelector("#EasterEgg").onchange = (e) => {
            if(e.target.files.length) {
                this.context.setWs(e.target.files);
                this.handleCreateRoom();
            }
        }
          
    }

    // componentDidUpdate(prevProps) {
    //     if(this.state.view !== prevProps.view)
    //     {
    //         if(this.state.view === 'mobile') {
                
    //         }
    //     }
    //   }


    handleNav = () => {
        if(this.state.slideout) {
            this.state.slideout.toggle()
        }
    }

    // handle PWA download
    handlePWA = () => {
        this.context.deferredPrompt.prompt();
        // Wait for the user to respond to the prompt
        this.context.deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the install prompt');
            } else {
            console.log('User dismissed the install prompt');
            }
            this.context.setDf(null);
        });
    }

    handleCreateRoom = () => {
          // handle visibility change
        let isPrivate;
        if(!this.state.roomIsPublic){
            // this.handleVisibility(false);
            isPrivate = true;
        } else {
            if( localStorage.getItem('visibility')) {
                isPrivate = !(localStorage.getItem('visibility')=='true')
            } else {
                isPrivate = false;
            }
        }
        this.context.teleport.createRoom(
            {nickname:this.state.userName,door:(this.state.roomIsPublic)?localStorage.getItem('createRoom'):null,isPrivate},
            (words) => {
                let oldroom = localStorage.getItem('createRoom');
                let roomChanged = false;
                if(oldroom && oldroom !== words){
                    roomChanged = true;
                }
                if(this.state.roomIsPublic){
                    localStorage.setItem("createRoom",words);
                }
              
                
                this.setState({
                    roomName : words,
                    route : true,
                    sender : { name : 'master', socketId : null, roomChanged,public:this.state.roomIsPublic}
                })
            },
            console.log
        );
    }

    handleCreateRoomDialog = (success) => {

        if(success) {

            this.setState({
                userName : localStorage.getItem('UserName'),
                createRoomDialogFlag : false,
            })

        } else {

            this.setState({
                alert : true,
                createRoomDialogFlag : true,
            })

        }

    }

    createNotification = (text,name="") => {
        if (document.hidden && ('Notification' in window)) {
          Notification.requestPermission((permission) => {
            if(!('permission' in Notification)) {
                Notification.permission = permission;
            }
            if (permission === "granted" && document.hidden) {
              navigator.serviceWorker.ready.then((registration) => {
                registration.showNotification('Teleport',{ body: text,data:{href:window.location.href,name}});
              });
            }
          });
        }
    } 

    handleJoinRoom = () => {

        let roomName = this.state.roomName;
        if(roomName.indexOf(':') !== -1){
            roomName = roomName.slice(roomName.indexOf(':')+1);
        }
        if(roomName !== ''){
            this.setState({
                roomName,
                route : true,
                sender : { name : 'slave', socketId : null },
            })
        }
    }

    handleJoinRoomText = (roomUpdatedName) => {

        this.setState({
            roomName : roomUpdatedName
        })

    }
    handleLongPress = () => {
        this.context.setWs("Clipboard");
        this.handleCreateRoom();
        return false;
    }

    handleToastClose = () => {

        this.setState({
            alert : false
        })

    }
    
    handleLocalRoomSelection = (socket) => {
        return () => {
            this.setState({
                roomName:"s-o-c",
                route : true,
                sender : {name : 'slave', socketId : socket},
            })
        }
    }

    renderRoomCards = () => {
        return (
            this.state.localRooms.map((room,i) => {
                return(
                    <React.Fragment>
                        { this.state.view === 'mobile' ? 
                            <Capsule key={i+room.nickname} name={room.nickname}  roomNameCallBack={this.handleLocalRoomSelection(room.sourceSocket)} /> :
                            <RoomCard key={i+room.nickname} name={room.nickname}  roomNameCallBack={this.handleLocalRoomSelection(room.sourceSocket)} />
                         }
                    </React.Fragment>
                )
            })
        )
    }

    renderGif = () => {
        return(
            <React.Fragment>
                <Player
                    autoplay
                    loop
                    src={scanGif}
                    style={ this.state.view === 'mobile' ? { height: '50vw', width: '50vw' } : { height: 'auto', width: 'auto' } }
                >
                    <Controls visible={false} buttons={['play', 'repeat', 'frame', 'debug']} />
                </Player>
            </React.Fragment>
        )
    }

    // Carousel Component
    // <React.Fragment>
    //     <Carousel style={(this.state.view === 'mobile' || this.state.localRooms.length === 1)? null:this.remove} itemPadding={[5, 10]}  itemsToShow={ 1 }>
    //         {this.renderRoomCards()}
    //     </Carousel>
    //     <Carousel style={(this.state.view === 'mobile' || this.state.localRooms.length === 1)? this.remove:null} itemPadding={[5, 10]}  itemsToShow={ 2 }>
    //         {this.renderRoomCards()}
    //     </Carousel>
    // </React.Fragment> 

    renderCarousel = () => {
        return(
            <React.Fragment>
                {this.state.localRooms.length === 0 ? 
                    <div className="gif" >
                        {this.renderGif()}
                        <p className="noPortalsubText" >No portals nearby...</p>
                    </div>
                    :  
                    <React.Fragment>
                        <Carousel style={(this.state.view === 'mobile' || this.state.localRooms.length === 1)? null:this.remove} itemPadding={[5, 10]}  itemsToShow={ 1 }>
                            {this.renderRoomCards()}
                        </Carousel>
                        <p className="hint" >Scanning active portals in your local network</p>
                    </React.Fragment>
                }
            </React.Fragment> 
        )
    }

    renderScrollList = () => {
        return(
            <React.Fragment>
                <div className="gif" >
                    {this.renderGif()}
                </div>
                <div className="noPortalsText">
                    { this.state.localRooms.length === 0 ? <p className="noPortalsubText" >No portals nearby...</p>   : 
                       this.renderRoomCards()
                    }
                </div>
            </React.Fragment>
        )
    }

    renderLocalRooms = () => {
        //this.state.view === 'mobile' ? 1 : ( this.state.localRooms.length > 1) ? 2 : 1
        
        return(
            <div className="rooms" >
                <div className="portalsText">
                    <p>Nearby portals</p>
                </div>
                { this.state.view === 'mobile' ? this.renderCarousel() : this.renderScrollList() }
            </div>
        )
    }

    renderPhoneHeader = () => {
        return(
            <React.Fragment>
                <Logo longPress={this.handleLongPress} view="mobile" />
                <h1 className="title" >TELEPORT</h1>
                <Nav  visible={(this.context.deferredPrompt)?true:false} handleNav={this.handleNav} handleDownloadClick={this.handlePWA} view="mobile" />
            </React.Fragment>
        )
    }

    handleAudioClick = () => {
        this.setState({micDisplay:false})
        this.state.analyzer.receive(()=>{
            this.setState({micDisplay:true})
        })
    }

    handleVisibility = (roomStatus) => { 
        this.context.teleport.setVisibility(roomStatus);
    }

    handleRoomPublic = (status) => {
        this.setState({roomIsPublic:status});
    }

    //Video component
    // <span className="text" >How it works ?</span>
    // <Video view={this.state.view}  className="video" />

    topComponent = ()=>{
        return(
            <React.Fragment>
                <div id="genLogo" className="logo" >
                    {this.state.view === "mobile" ? this.renderPhoneHeader() : <Logo view="desktop" /> }
                </div>
                { this.state.view === 'mobile' ? 
                    <div className="buttons" >
                        <div className="oneLineButtons" >
                            <CreateRoomMobBtn handleClick={this.handleCreateRoom} />
                            <div className="lock" >
                                <RoomStatusIconButton status={this.state.roomIsPublic} handleClick={this.handleRoomPublic} handleBadgeClick={()=>{this.setState({ openRoomInfo : true })}} />
                            </div>
                        </div>
                        <div style={{ backgroundColor: '#373737', width : '80%', marginBottom: '2vh' }} >
                            <Divider variant="middle" />
                        </div>
                        <div style={{ justifyContent: 'center'}}className="oneLineButtons">
                            <div style={{display:"flex", alignItems:"center",justifyContent:"flex-start",background:"#373737",width:"88%",minHeight:"45px"}}>
                            <HistortyBtn view={this.state.view} handleClick={()=>{ this.setState({ displaySuggestions : !this.state.displaySuggestions  }) }} />
                            <JoinRoomMobName show={this.state.displaySuggestions} analyzer={this.state.analyzer} textInput={this.handleJoinRoomText} />
                            </div>
                        </div>
                        <JoinRoomMobBtn handleClick={this.handleJoinRoom} />
                    </div> :
                    <div style={{ paddingLeft : '3vw' }} >
                        <p className="heading" >Teleport files easily and efficiently</p>
                        <p className="subheading" >Using just a web browser, experience unlimited file transfers across any device on Earth</p>
                        <div className="buttons" >
                            <div className="oneLineButtons" >
                                <CreateRoomBtn handleClick={this.handleCreateRoom} />
                                <div className="lock" >
                                    <RoomStatusIconButton status={this.state.roomIsPublic} handleClick={this.handleRoomPublic} handleBadgeClick={()=>{this.setState({ openRoomInfo : true })}} />
                                </div>
                            </div>
                            <div style={{ backgroundColor: '#373737', width : '70%'}} >
                                <Divider variant="middle" />
                            </div>
                            <div className="oneLineButtons" >
                                <HistortyBtn view={this.state.view} handleClick={()=>{ this.setState({ displaySuggestions : !this.state.displaySuggestions  }) }} />
                                <JoinRoomName show={this.state.displaySuggestions}  analyzer={this.state.analyzer} textInput={this.handleJoinRoomText} />
                                <JoinRoomBtn handleClick={this.handleJoinRoom} />
                            </div>
                        </div>
                    </div>
                }
                <div className="audio">
                    { this.state.micDisplay ? 
                        <MicButton handleAudioClick={this.handleAudioClick} />  
                        :
                        <Player
                            autoplay
                            loop
                            src={audioGif}
                            style={ this.state.view === 'mobile' ? { height: '50vw', width: '50vw' } : { height: '5vw', width: '5vw' } }
                        >
                            <Controls visible={false} buttons={['play', 'repeat', 'frame', 'debug']} />
                        </Player>
                    }
                    <span>Join a portal via sound waves!</span>
                    <div>
                    {/* <GoogleLogin
                        clientId="1046785123269-gg6ob1gdpql3nfdd9h9ispclce9b8ipj.apps.googleusercontent.com"
                        buttonText="Login"
                        theme="dark"
                        icon={false}
                        style={{ backgroundColor:"#fe752f!important"}}
                        onSuccess={(res) => {
                            console.log("Login succ",res)
                            let obj = res.profileObj;
                            obj.ttl = (+new Date + 1296000);
                            localStorage.setItem("auth",JSON.stringify(obj));
                        }}
                        onFailure={(res) => {
                            console.log("Login fail",res)
                            localStorage.removeItem("auth")
                        }}
                        cookiePolicy={'single_host_origin'}
                    />
                       <GoogleLogout
                        clientId="1046785123269-gg6ob1gdpql3nfdd9h9ispclce9b8ipj.apps.googleusercontent.com"
                        buttonText="Logout"
                        theme="dark"
                        icon={false}
                        onLogoutSuccess={(suc) => {
                            console.log("logout success",suc);
                            localStorage.removeItem("auth")
                        }}
                        onFailure={(err) => { 
                            console.log("logout fail",err)
                        }}
                        >
                        </GoogleLogout> */}
                    </div>
                </div>
            </React.Fragment>
        )
    }

    bottomComponent = ()=> {
        return(
            <React.Fragment>
                { this.state.view === "mobile" ? null : <Nav handleDownloadClick={this.handlePWA} visible={(this.context.deferredPrompt)?true:false} view="desktop" /> }
                { this.renderLocalRooms() }
                { this.state.view === "mobile" ? null : <p className="hint" >Scanning devices with active portals in your local network</p> }
            </React.Fragment>
        )
    }

    renderMobile = ()=> {
        return(
            <React.Fragment>
                {this.topComponent()}
                {this.bottomComponent()}
            </React.Fragment>
        )
    }

    renderDesktop = ()=> {
        return(
            <React.Fragment>
                <div className="left">
                    {this.topComponent()}
                </div>
                <div className="right">
                    {this.bottomComponent()}
                </div>
            </React.Fragment>
        )
    }

    render(){

        if(this.state.route){ 
            this.props.history.push('/portal/'+this.state.roomName, {
                sender : this.state.sender,
            })
        }
        return(
            <React.Fragment>
                <NavMenu display={this.state.slideout?true:false} visible={(this.context.deferredPrompt)?true:false} handleNav={this.handleNav} handleDownloadClick={this.handlePWA} /> 
                <div id="homePage" className={ this.state.createRoomDialogFlag ? "homeBgBlur" : "homeContainer" } >
                    <div className="stars" ></div>
                    { this.state.view === 'mobile' ?    
                        this.renderMobile() : this.renderDesktop() }
                    <CreateRoomDialog show={this.state.createRoomDialogFlag} updatedNameCallBack={this.handleCreateRoomDialog} />
                    <InfoPrompt view={this.state.view} info="room" open={this.state.openRoomInfo} handleClose={()=>{this.setState({ openRoomInfo : false })}} />
                    {/* <InputViolationToast open={this.state.alert} errorText={this.state.errCode} closeSnack={this.handleToastClose}  /> */}
                </div>
            </React.Fragment>
        )

    }

}

export default Home;